module.exports = __webpack_public_path__ + "img/add-circle-outline.0d0c93ef.svg";